
/**
 *
 * App
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */

import React from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { Switch, Route } from 'react-router-dom';

import HomePage from 'containers/HomePage';
import TestPage from 'containers/TestPage';
import CodebookDemo from 'containers/CodebookDemo';
import NotFoundPage from 'containers/NotFoundPage/';
import useCollisionStyle from 'utils/useCollisionStyle';

import Nav from 'components/Nav';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import '../../lib/polyfills/dataset.js';
import '../../lib/polyfills/selectedOptions.js';

import useCollisionTooltips from './useCollisionTooltips';

const AppWrapper = styled.div`
`;

export default function App() {
  useCollisionStyle('front/components/noty.css');
  useCollisionTooltips();

  return (
    <AppWrapper>
      <Helmet
        titleTemplate="%s - Forms"
        defaultTitle="Collision Charts"
      >
        <meta name="description" content="Something something forms" />
      </Helmet>
      <Nav />
      <Switch>
        <Route exact path="/" component={HomePage} />
        <Route exact path="/advanced" component={HomePage} />
        <Route exact path="/test" component={TestPage} />
        <Route exact path="/search" component={CodebookDemo} />
        <Route exact path="/health_check" />
        <Route path="" component={NotFoundPage} />
      </Switch>
    </AppWrapper>
  );
}



// WEBPACK FOOTER //
// ./app/containers/App/index.js